import React from 'react';

import { 
  Ability,
  Character,
  CharacterAbility,
  CharacterSpell,
  SpellsFromList,
} from "@dndModels";

interface Props {
  character?: Character;
  obj: CharacterAbility | CharacterSpell;
  casting_time: string;
  type: string;
  level: number;
}

export default function CharacterCastButtonPDF({
  character,
  obj,
  casting_time,
  type,
  level
}: Props) {
  const level2 = level === -1 ? obj.level : level;
  
  const getResourceStuff = (slot_type = "Slots") => {
    let resource_consumed = "";
    let amount_consumed = 0;
    let and_special = false;
    let slot = false;
    if (obj instanceof CharacterAbility) {
      const the_ability = obj.the_ability;
      if (the_ability instanceof SpellsFromList) {
        if (the_ability.spell_overrides.slot_override === "Don't Override") {
          resource_consumed = "Slot";
          amount_consumed = 1;
          slot = true;
        } else if (the_ability.spell_overrides.slot_override === "Or Special Resource") {
          if (type === "Spell") {
            resource_consumed = "Slot";
            amount_consumed = 1;
            slot = true;
          } else {
            if (slot_type === "Special") {
              resource_consumed = the_ability.resource_consumed;
              amount_consumed = the_ability.spell_overrides.consumed_resource.amount_consumed;
            } else if (slot_type === "Charge") {
              console.log("Not implemented");
            } else {
              resource_consumed = slot_type;
              amount_consumed = the_ability.spell_overrides.consumed_resource.amount_consumed;
            }
          }
        } else if (the_ability.spell_overrides.slot_override === "And Special Resource") {
          // This should be similar to Or Special Resource
          // Just get whatever slots there are at that level.
          // Take created first, then pact, then regular
          resource_consumed = slot_type;
          amount_consumed = the_ability.spell_overrides.consumed_resource.amount_consumed;
          and_special = true;
          slot = true;
        } else if (the_ability.spell_overrides.slot_override === "Only Special Resource") {
          resource_consumed = the_ability.resource_consumed;
          amount_consumed = the_ability.spell_overrides.consumed_resource.amount_consumed;
        }
      } else if (the_ability instanceof Ability) {
        resource_consumed = the_ability.resource_consumed;
        amount_consumed = the_ability.consumed_resource.amount_consumed;
      }
    }
    return { resource_consumed, amount_consumed, slot, and_special };
  }

  const getReturnString = () => {
    if (obj instanceof CharacterAbility) {
      const the_ability = obj.the_ability;
          
      if (the_ability) {
        let { resource_consumed, amount_consumed, slot } = getResourceStuff();
        
        if (slot) {
          resource_consumed = "Slot";
        } else if (!["Charge","None"].includes(resource_consumed)) {
          resource_consumed = "Special";
        }
        if (resource_consumed === "Slot" || type === "Spell") {
        
          if (level2 === 0) {
            return "At Will";
          } else {
            // Get the slots for the level
            return `Level ${level2} Slot`;
          }
        } else if (character && (the_ability instanceof Ability || 
          the_ability instanceof SpellsFromList) && 
          resource_consumed === "Charge") {
          // obj.source_id; // This is the true_id of the CharacterItem that grants this ability
          const item_id = obj.char_feature?.use_item_id ?? "";
          const item_finder = character.items.filter(o => o.true_id === item_id);
          if (item_finder.length === 1) {
            const char_item = item_finder[0];
            return `${amount_consumed} Charge${amount_consumed > 1 ? "s" : ""} of ${char_item.max_charges}`;
          }
        } else if (resource_consumed === "Special") {
          return obj.use_string({ amount_consumed, obj: character, ignore_used: true });
        } else if (resource_consumed === "None") {
          return obj.use_string({ amount_consumed, obj: character, ignore_used: true });
        } else if (character) {
          // Get the resources
          const resources = character.resources.filter(o => o.type_id === resource_consumed);
          
          if (resources.length > 0) {
            return obj.use_string({ amount_consumed, obj: character, ignore_used: true });
          }
        }
      }
    } else {
      const spell = obj;
      // const self_condition_ids = spell.self_condition();
      if (spell.level === 0 || (spell.at_will && level2 === spell.level)) {
        return "At Will";
      } else if (spell.ritual_only || casting_time === "Ritual") {
        return "Ritual";
      } else {
        return `Level ${level2} Slot`;
      }
    }
  }
  const return_string = getReturnString();
  if (return_string && return_string.length > 12) {
    return (<span style={{ fontSize: "8px" }}>{return_string}</span>);
  }
  return <>{ return_string }</>;
}
